import { render, staticRenderFns } from "./ForumComponent.vue?vue&type=template&id=795b8dac&scoped=true"
import script from "./ForumComponent.vue?vue&type=script&lang=js"
export * from "./ForumComponent.vue?vue&type=script&lang=js"
import style0 from "./ForumComponent.vue?vue&type=style&index=0&id=795b8dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b8dac",
  null
  
)

export default component.exports